import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { canonicalUrl, getSeoForPath, ogImageUrl, siteName } from '../seo/routes';
import { DEFAULT_LOCALE } from '../seo/site';

export function SeoHead() {
  const { pathname } = useLocation();
  const seo = getSeoForPath(pathname);
  const url = canonicalUrl(pathname);
  const ogTitle = seo.ogTitle ?? seo.title;
  const image = ogImageUrl();
  const robots = seo.noindex ? 'noindex, nofollow' : 'index, follow';

  return (
    <Helmet>
      <html lang="fr" />
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteName()} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={DEFAULT_LOCALE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
